import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { Link } from "react-router-dom";

// Custom styles for elements that Bootstrap classes cannot cover.
const CustomAboutStyles = () => (
  <style type="text/css">{`
    .legacy-box-color {
      color: #6a2e4d;
    }
    .play-btn-custom {
      width: 60px;
      height: 60px;
      background-color: rgba(106, 46, 77, 0.8);
      transition: transform 0.2s ease, background-color 0.2s ease;
    }
    .play-btn-custom:hover {
      background-color: rgba(106, 46, 77, 1);
      transform: scale(1.1);
    }
    /* Custom white border with 10px width */
    .border-custom-white {
       border-top: 20px solid white;
border-right: 20px solid white;
border-left: none;
border-bottom: none;
    }
    /* Custom height for the video container */
    .h-custom-140 {
        height: 140px;
    }

    @media (min-width: 992px) {
      .legacy-box-clipped {
 
        padding-right: 4rem;
      }
      .video-container-overlap {
        margin-left: -15%;
        width: 250px;
        height: 180px;
      }
    }
  `}</style>
);
   const useWindowSize = () => {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
  useEffect(() => {
    const handleResize = () => setSize([window.innerWidth, window.innerHeight]);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return size;
};

const AboutThree = () => {
  const [videoSrc, setVideoSrc] = useState("");
  const modalRef = useRef(null);
  const [width] = useWindowSize();
  const isMobile = width < 768;
    const [count, setCount] = useState(0);
      const [start, setStart] = useState(false); // flag to start counter
  
  const youtubeVideoUrl = "https://www.youtube.com/embed/MCSl7nayYPE?autoplay=1";

    useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 700 && !start) {
        setStart(true); // start counter when scrolled to 800px
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [start]);

  // Counter logic
  useEffect(() => {
    if (start && count < 15) {
      const interval = setInterval(() => {
        setCount((prev) => prev + 1);
      }, 80);

      return () => clearInterval(interval);
    }
  }, [start, count]);

  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement) {
      const handleModalShow = () => setVideoSrc(youtubeVideoUrl);
      const handleModalHide = () => setVideoSrc(""); 
      modalElement.addEventListener('show.bs.modal', handleModalShow);
      modalElement.addEventListener('hidden.bs.modal', handleModalHide);
      return () => {
        modalElement.removeEventListener('show.bs.modal', handleModalShow);
        modalElement.removeEventListener('hidden.bs.modal', handleModalHide);
      };
    }
  }, [youtubeVideoUrl]);

const videoContainerStyle = {
  cursor: "pointer",
  border: "10px solid white",
  width: "220px",   // no !important in React inline styles
  height: "160px",
  backgroundColor: "#fff",
  ...(isMobile
    ? {} // mobile: default
    : {
        position: "relative",
        right: "37px",
      }),
};

  return (
    <>
      <CustomAboutStyles />
      {/* <!-- tp-about-3 start  --> */}
      <div className="py-5 mt-5"> {/* Replaced pt-160 with standard Bootstrap padding */}
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row"> {/* Replaced tp-flex-reverse */}
            <div className="col-lg-6">
              <div className="pe-lg-4"> {/* Replaced pr-40 */}
                <div className="mb-2"> {/* Replaced mb-10 */}
                  <span>Elevate Your Business to New Heights</span>
                </div>
                <h3 className="h2 fw-bold mb-4"> {/* Replaced tp-ab-title and mb-35 */}
                  Innovative Elevator Solutions
                </h3>
                <p>
                  We specialize in providing cutting-edge elevator systems
                  designed for safety, efficiency, and reliability. Whether it's
                  for residential, commercial, or industrial use, our elevators
                  are crafted to meet the highest standards. Experience seamless
                  vertical transportation with advanced technology and
                  unparalleled support tailored to your needs.
                </p>
                <div className="mb-5"> {/* Replaced mb-40 */}
                  <Link to="/service" className="tp-btn"> {/* Assuming .tp-btn is a custom global class */}
                    Explore Our Services
                    <span>
                      {/* SVGs */}
                      <svg width="22" height="8" viewBox="0 0 22 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z" fill="currentColor"></path></svg>
                      <svg width="22" height="8" viewBox="0 0 22 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z" fill="currentColor"></path></svg>
                    </span>
                  </Link>
                </div>
                <div>
                </div>
                {/* VIDEO SECTION with Bootstrap Classes */}
                <div style={{width:isMobile?'':"900px"}} className="d-flex flex-column flex-lg-row align-items-center  justify-content-center mt-5">
                  <div className="legacy-box-clipped  p-4 p-lg-5 rounded-4  d-flex align-items-center w-100 w-lg-auto mb-n3 mb-lg-0">
                    <div className="display-4 legacy-box-color me-3">{count}+</div>
                    <div className="text-uppercase fw-semibold text-secondary" style={{ letterSpacing: '1px' }}> {/* Kept letterSpacing as it has no BS alternative */}
                      Years of <br /> Experience in Elevators Industries
                    </div>
                  </div>
<div
  data-bs-toggle="modal"
  data-bs-target="#videoModal"
  className={`position-relative video-container-overlap rounded-4 shadow-lg d-flex align-items-center justify-content-center border-custom-white`}
  style={videoContainerStyle} // inline styles now take effect
>
  {/* Logo as image */}
  <img
    src="assets/img/logo/lumetiq_logo.png"
    alt="Lumetiq Logo"
    className="img-fluid"
    style={{
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain"
    }}
  />

  {/* Play button overlay */}
  <div className="position-absolute top-50 start-50 translate-middle">
    <div
      className="play-btn-custom rounded-circle border-0 text-white d-flex align-items-center justify-content-center fs-4"
      aria-label="Play Video"
    >
      <FaPlay />
    </div>
  </div>
</div>


                </div>
              </div>
            </div>
            <div className="col-lg-6">
              
              <div className="text-center text-lg-end"> {/* Replaced text-md-end w-img */}
                <img src="assets/img/about/about-2.jpg" className="img-fluid" alt="Elevator Solutions" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- tp-about-3 end  --> */}

      {/* Bootstrap Modal HTML */}
      <div className="modal fade" id="videoModal" tabIndex="-1" aria-labelledby="videoModalLabel" aria-hidden="true" ref={modalRef}>
        <div style={{display:"flex",justifyContent:"center"}} className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content bg-transparent border-0">
            <div className="modal-header border-0">
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body p-0">
              <div className="ratio ratio-16x9">
                <iframe src={videoSrc} title="Elevator Technology Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutThree;